// extracted by mini-css-extract-plugin
export var bodySections = "_4j-8";
export var gray = "_4j-7";
export var green = "_4j-4";
export var iconContainer = "_4j-9";
export var iconWidgetContainer = "_4j-1";
export var phoneIcon = "_4j-2";
export var red = "_4j-5";
export var statusDot = "_4j-3";
export var widgetContainer = "_4j-0";
export var yellow = "_4j-6";